import { ComponentPropsWithoutRef, FC } from 'react';

import Icon, { IconView, IconColor, IconScale } from 'bloko/blocks/icon';

interface LoadingProps extends ComponentPropsWithoutRef<'svg'> {
    initial?: IconColor;
    scale?: IconScale.Small | IconScale.Medium;
}

const Loading: FC<LoadingProps> = ({ scale = IconScale.Small, ...otherProps }) => (
    <Icon initial={IconColor.Blue60} scale={scale} {...otherProps} view={IconView.Loader} />
);

export default Loading;
export { IconColor as LoadingColor };
export { IconScale as LoadingScale };
